import FAQItem from "../components/FAQItem/FAQItem";
import SupportPHPMailer from "../components/Forms/SupportPHPMailer";

import faqs from "../data/faqs";

const Support = () => {
    return (
        <div className={`content-width-container`}>
            <h1>Support</h1>
            <p style={{
                fontSize: '1.2rem',
                color: '#282828'
            }}>
                Welcome to DimeDock! We're here to help you take control of your finances. If you have any questions or need assistance, please fill out the form below.
            </p>

            <SupportPHPMailer />

            <hr style={{margin: '3rem 0'}} />

            <div>
                <h2>FAQs</h2>

                {faqs.map((faq) => (
                    <FAQItem
                        key={faq.id}
                        question={faq.question}
                        answer={faq.answer}
                        tags={faq.tags}
                    />
                ))}
            </div>
        </div>
    );
}

export default Support;
